import { FEEDBACK_ACTION as ACTION_TYPE } from '../types/actionTypes';
const setAutotaggingPredictionId = dispatch => predictionId => dispatch({
  type: ACTION_TYPE.SET_AUTOTAGGING_PREDICTION_ID,
  payload: {
    autotaggingPredictionId: predictionId
  }
});
const setKeywordPredictionId = dispatch => predictionId => dispatch({
  type: ACTION_TYPE.SET_KEYWORD_PREDICTION_ID,
  payload: {
    keywordPredictionId: predictionId
  }
});
const setJobId = dispatch => jobId => dispatch({
  type: ACTION_TYPE.SET_JOB_ID,
  payload: {
    jobId
  }
});
// sometimes we need to update multiple state values at once
const setMultiple = dispatch => payload => dispatch({
  type: ACTION_TYPE.SET_MULTIPLE,
  payload
});
export default {
  setAutotaggingPredictionId,
  setKeywordPredictionId,
  setJobId,
  setMultiple
};